import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import HomePage from './pages/HomePage';
import TheHousePage from './pages/TheHousePage';
import FounderPage from './pages/FounderPage';
import PortfolioPage from './pages/PortfolioPage';
import IntellectualPropertyPage from './pages/IntellectualPropertyPage';
import StewardshipPage from './pages/StewardshipPage';
import InsightsPage from './pages/InsightsPage';
import PaperViewPage from './pages/PaperViewPage';
import ContactPage from './pages/ContactPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import AdminPage from './pages/AdminPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Main routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/the-house" element={<TheHousePage />} />
            <Route path="/founder" element={<FounderPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/intellectual-property" element={<IntellectualPropertyPage />} />
            <Route path="/stewardship" element={<StewardshipPage />} />
            <Route path="/insights" element={<InsightsPage />} />
            <Route path="/insights/:id" element={<PaperViewPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/admin" element={<AdminPage />} />

            {/* Redirects from old routes */}
            <Route path="/about" element={<Navigate to="/the-house" replace />} />
            <Route path="/companies" element={<Navigate to="/portfolio" replace />} />
            <Route path="/companies/*" element={<Navigate to="/portfolio" replace />} />
            <Route path="/ip" element={<Navigate to="/intellectual-property" replace />} />
            <Route path="/philanthropy" element={<Navigate to="/stewardship" replace />} />
            <Route path="/publications" element={<Navigate to="/insights" replace />} />
            <Route path="/publications/:id" element={<Navigate to="/insights" replace />} />

            {/* 404 */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
